import {ProductData} from "@/entities/product";
import {formatDayMonth, today} from "@/shared/lib/date";
import {DeliveryItem} from "../types";

type Result = {
    items: DeliveryItem[];
};

const buildDeliveryText = (
    date: string | null,
    deliveryPay: number
) => {
    if (!date) {
        return "";
    }

    const text = `с ${formatDayMonth(date)}`;

    return deliveryPay > 0
        ? text
        : `${text} бесплатно`;
};

const buildExpressText = (date: string | null) => {
    if (!date) {
        return "";
    }

    return `экспресс-доставка с ${formatDayMonth(date)}`;
};

export const getProductDeliveryData = (
    productDataCurrent: ProductData
): Result | null => {
    const deliveryInformation = productDataCurrent.deliveryInformation;

    if (!deliveryInformation) {
        return null;
    }

    const {brandShop, pvz, courier} = deliveryInformation;

    const items: DeliveryItem[] = [];

    if (brandShop.count > 0) {
        items.push({
            key: "brandShop",
            icon: "productDeliveryBrandShopIcon",
            count: brandShop.count,
            text:
                brandShop.delivery_date === today()
                    ? "сегодня бесплатно"
                    : buildDeliveryText(
                        brandShop.delivery_date,
                        0
                    ),
            expressText: buildExpressText(
                brandShop.delivery_date_express
            ),
        });
    }

    if (pvz.count > 0) {
        items.push({
            key: "pvz",
            icon: "productDeliveryPickupIcon",
            count: pvz.count,
            text: buildDeliveryText(
                pvz.delivery_date,
                pvz.delivery_pay
            ),
            expressText: buildExpressText(
                pvz.delivery_date_express
            ),
        });
    }

    items.push({
        key: "courier",
        icon: "productDeliveryCourierIcon",
        text: buildDeliveryText(
            courier.delivery_date,
            courier.delivery_pay
        ),
        expressText: buildExpressText(
            courier.delivery_date_express
        ),
    });

    return {items};
};
